import { useSelector } from 'react-redux';

import { selectFirstOfferInstallments } from 'selectors/entities/recurringOffers/recurringOffers';
import { useTranslations } from 'utils/translations/useTranslations';

type RecurringLabelsProps = {
  interval: number;
};

function RecurringLabels({ interval }: RecurringLabelsProps) {
  const i18n = useTranslations();
  const installments = useSelector(selectFirstOfferInstallments);

  const instalmentsWithSameAmount = !!(
    installments?.length &&
    installments?.every(
      instalment => instalment.amount === installments[0].amount,
    )
  );

  const intervalText = instalmentsWithSameAmount
    ? i18n.t('paymentOptions.recurringPayment.interval', {
        interval: `${interval}`,
      })
    : i18n.t('paymentOptions.recurringPayment.firstInstalment');

  return <div>{intervalText}</div>;
}

export { RecurringLabels };
